function initTicketContextPicker(picker) {
  const type = picker.querySelector("[data-ticket-context-type]");
  const query = picker.querySelector("[data-ticket-context-query]");
  const id = picker.querySelector("[data-ticket-context-id]");
  const search = picker.querySelector(".office-ticket-context-picker__search");
  const results = picker.querySelector("[data-ticket-context-results]");
  const status = picker.querySelector("[data-ticket-context-status]");
  const chosen = picker.querySelector("[data-ticket-context-chosen]");
  const messages = {
    min: picker.dataset.searchMin,
    searching: picker.dataset.searching,
    choose: picker.dataset.searchChoose,
    empty: picker.dataset.searchEmpty,
    error: picker.dataset.searchError,
    chosen: picker.dataset.searchChosen,
    required: picker.dataset.searchRequired,
  };
  let timer;
  let request;

  function clearSelection() {
    id.value = "";
    chosen.hidden = true;
    chosen.textContent = "";
  }

  function resetResults(message) {
    results.replaceChildren();
    results.hidden = true;
    status.textContent = message;
  }

  function syncType() {
    const hasType = Boolean(type.value);
    search.hidden = !hasType;
    query.value = "";
    clearSelection();
    resetResults(messages.min);
  }

  type.addEventListener("change", () => {
    clearTimeout(timer);
    request?.abort();
    syncType();
    if (type.value) query.focus();
  });

  query.addEventListener("input", () => {
    clearTimeout(timer);
    request?.abort();
    clearSelection();
    query.setCustomValidity("");
    const value = query.value.trim();
    if (value.length < 2) {
      resetResults(messages.min);
      return;
    }

    resetResults(messages.searching);
    timer = window.setTimeout(async () => {
      request = new AbortController();
      const url = new URL(picker.dataset.searchUrl, window.location.origin);
      url.searchParams.set("type", type.value);
      url.searchParams.set("q", value);
      try {
        const response = await fetch(url, { credentials: "same-origin", signal: request.signal, headers: { Accept: "application/json" } });
        if (!response.ok) throw new Error("search failed");
        const data = await response.json();
        if (query.value.trim() !== value) return;
        results.replaceChildren();
        (data.items || []).forEach((item) => {
          const option = document.createElement("option");
          option.value = item.id;
          option.textContent = item.label;
          option.dataset.label = item.label;
          results.append(option);
        });
        results.hidden = results.options.length === 0;
        status.textContent = results.options.length ? messages.choose : messages.empty;
      } catch (error) {
        if (error.name !== "AbortError") resetResults(messages.error);
      }
    }, 250);
  });

  results.addEventListener("change", () => {
    const selected = results.selectedOptions[0];
    if (!selected) return;
    id.value = selected.value;
    query.value = selected.dataset.label;
    query.setCustomValidity("");
    chosen.textContent = `${messages.chosen}: ${selected.textContent}`;
    chosen.hidden = false;
    results.hidden = true;
    status.textContent = messages.chosen;
  });

  picker.closest("form").addEventListener("submit", (event) => {
    if (type.value && !id.value) {
      event.preventDefault();
      query.setCustomValidity(messages.required);
      query.reportValidity();
    }
  });

  search.hidden = !type.value;
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-ticket-context-picker]").forEach(initTicketContextPicker);
  document.querySelector("[data-ticket-reopen-on-error]")?.click();

  const dialog = document.getElementById("office-ticket-create-dialog");
  if (!dialog) return;
  let opener;
  document.querySelectorAll("[data-ticket-create-open]").forEach((button) => {
    button.addEventListener("click", () => {
      opener = button;
      dialog.showModal();
      dialog.querySelector('input[name="ticket[title]"]')?.focus();
    });
  });
  dialog.querySelector("[data-ticket-create-close]")?.addEventListener("click", () => dialog.close());
  dialog.addEventListener("close", () => opener?.focus());
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) dialog.close();
  });
  if (dialog.dataset.openOnError) dialog.showModal();
});
